import React, { useEffect, useState } from "react";
import Lottie from "react-lottie";
import { useMediaQuery } from "react-responsive";
import * as animationData from "../../../../../animationStyle/Animation - 1712748235290.json";

function ThankParticipationPage() {
    const isTablet = useMediaQuery({ query: "(max-width: 650px)" });
    const [timeCount, setTimeCount] = useState(30);
    const defaultOptions = {
        loop: true,
        autoplay: true,
        animationData: animationData,
        rendererSettings: {
            preserveAspectRatio: "xMidYMid slice",
        },
    };

    // Increment timeCount every second
    useEffect(() => {
        if (timeCount <= 0) return;

        const interval = setInterval(() => {
            setTimeCount((prevCount) => {
                if (prevCount <= 1) {
                    clearInterval(interval);
                    window.close();
                    console.log("Time is up, closing the window.");
                    return 0;
                }
                return prevCount - 1;
            });
        }, 1000);

        return () => clearInterval(interval);
    }, [timeCount]);


    return (
        <div
            className="valign-wrapper justify-center column"
            style={{ height: "100vh" }}
        >
            <span className="font-18px" style={{ textAlign: "center", gap: "5px" }}>
                <Lottie
                    options={defaultOptions}
                    style={{ width: isTablet ? "200px" : "350px", height: isTablet ? "200px" : "350px" }}
                />
                <h2 className={`margin-0px ${isTablet ? "font-25px" : "font-30px"}`}>
                    We truly value your presence in our e-auction – thank you!
                </h2>
                <p>We truly appreciate you taking the time to participate.</p>
                <button
                    className={`button-style pointer font-16px select-wrapper cercle-purple white-text mt-2`}
                    style={{ padding: "8px 20px" }}
                    onClick={() => window.close()}
                >
                    Close Live Room ({timeCount} sec)
                </button>
            </span>
        </div>
    );
}

export default ThankParticipationPage;
